import RESOURCE_TYPES_CONFIG from "./resourceTypesConfig";
import { getTopK } from "./getTopK";
export {
    getTopKResourceTypes,
    parsePreferenceResourceTypes,
};

const RESOURCE_TYPE_GROUPINGS = {
    "Commodity": "Quote",
    "Company": "Quote",
    "Currency": "Quote",
    "Dataarticle": "Story",
    "Feature": "Story",
    "Fund": "Quote",
    "Index": "Quote",
    "Interactive": "Story",
    "Quicktake": "Story",
    "Slideshow": "Story",
    "Story": "Story",
    "Video": "Video",
    "Storythread": "Storythread",
};

const STATS_TIMERANGE = "1y";

function getTopKResourceTypes(array, k = RESOURCE_TYPES_CONFIG.targetingParamLimit) {
    return getTopK(array, k);
}

function parsePreferenceResourceTypes(userInfo) {
    let preferenceResourceTypes = [];
    const resourceTypeScoreMap = {};
    const {
        Resourcetype: {
            Confidence = 0,
            Preferences = [],
        } = {},
    } = userInfo;

    // Only consider if confidence is greater than or equal to the threshold
    if (Confidence < RESOURCE_TYPES_CONFIG.confidenceThreshold) {
        return preferenceResourceTypes;
    }

    if (!Array.isArray(Preferences)) {
        return preferenceResourceTypes;
    }

    Preferences.forEach((type) => {
        if (!Object.prototype.hasOwnProperty.call(type, "assetType")) {
            return;
        }

        const grouping = RESOURCE_TYPE_GROUPINGS[type.assetType];

        if (!grouping) {
            return;
        }

        let score;

        if (type.statsInfo && type.statsInfo[STATS_TIMERANGE]) {
            score = type.statsInfo[STATS_TIMERANGE].score;
        }

        resourceTypeScoreMap[grouping] = (resourceTypeScoreMap[grouping] || 0) + score;
    });

    preferenceResourceTypes = Object.keys(resourceTypeScoreMap).map((grouping) => {
        return {
            id: grouping,
            type: "Resourcetype",
            derivedScore: resourceTypeScoreMap[grouping],
        };
    });

    return preferenceResourceTypes;
}
